export default __webpack_public_path__ + "static/media/instagram.84a96cf8.svg";